/**
 * The plain notification of the back office: 3 s, bottom centre, no action.
 */
import { toast } from 'sonner';

export const SNACKBAR_DURATION_MS = 3000;

export const snackbar = (message: string): void => {
  toast(message, { position: 'bottom-center', duration: SNACKBAR_DURATION_MS });
};
